
/**
  * Do not change! File was auto generate.
  *
  */
import { ReactElement, SVGProps } from 'react';
import { ReactComponent as ClipIconComponent } from "./clip-icon.svg";

export const ClipIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return <ClipIconComponent {...props} />;
};
